import { useNotification as naiveNotification } from '@gohighlevel/ghl-ui';
const NotificationDuration = 6000;
export function useNotification() {
    const notification = naiveNotification();
    const create = (props) => notification.create(Object.assign(Object.assign({}, props), { duration: NotificationDuration }));
    return {
        create,
    };
}
